import logoKeb from '../../../src/images/keb_velo_1.png' //image logo
import logoMl from '../../../src/images/logo_ml_pink.png' //image logo

import { Route, Link, Routes, useLocation } from 'react-router-dom';

//MUI
import LanguageIcon from '@mui/icons-material/Language';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
import { langSlice } from "../../store/langSlice.js";

function BannerMoutchicLoisirs({ title }) { // component to manage the first step of shopping : choosing place and time

    const dispatch = useDispatch();
    const lang = useSelector(getLang) //global state : shopping step

    const location = useLocation();
    const { hash, pathname, search } = location;
    console.log(pathname);

    return (
        <div className="header-ml">

            <div className="header-ml-container">
                <div className="header-ml-left">
                    <h3>{title}</h3>
                </div>
                <div className="header-ml-middle">

                    <img src={logoMl} alt="logo moutchic loisirs, location de cycles" />
                </div>
                <div className="header-ml-right">

                    {pathname.includes("manager") ? //we need language change only for online booking, not for manager
                        null
                        :
                        <div className="header-ml-right-select-lang">
                            <LanguageIcon />
                            <Select
                                size="small"
                                value={lang}
                                onChange={e => dispatch(langSlice.actions.setLang(e.target.value))}
                            >
                                <MenuItem value={"fr"}>FR</MenuItem>
                                <MenuItem value={"gb"}>ENG</MenuItem>
                            </Select>

                        </div>

                    }

                    <img src={logoKeb} alt="logo moutchic loisirs, location de cycles" />

                </div>
            </div>
        </div>
    )
}




export default BannerMoutchicLoisirs
